//SEATING_OPTION list
export const SEATING_OPTION_LIST_REQUEST = 'SEATING_OPTION_LIST_REQUEST';
export const SEATING_OPTION_LIST_SUCCESS = 'SEATING_OPTION_LIST_SUCCESS';
export const SEATING_OPTION_LIST_FAIL = 'SEATING_OPTION_LIST_FAIL';
